// TODO: Date, Datetime when we have a Vue date component
export default [
  {
    type: 'String',
    description: 'Text',
  },
  {
    type: 'Integer',
    description: 'Whole number',
  },
  {
    type: 'Decimal',
    description: 'Decimal number',
  },
  {
    type: 'Time',
    description: 'Time',
  },
  {
    type: 'Boolean',
    description: 'Checkbox',
  },
]
